import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'ms-horses-silk',
    template: `
        <i class="sports-silk-placeholder" [class.hidden]="silkVisible"></i>
        <img #imgSilk src="{{ src }}" alt="{{ description }}}" class="jockey-silk" [class.hidden]="!silkVisible" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HorsesSilkComponent implements OnInit, OnDestroy {
    private isSilkLoaded = false;
    @Input() src: string;
    @Input() description: string;
    @ViewChild('imgSilk', { static: true }) img: ElementRef;

    private loadListener: () => void;

    constructor(
        private renderer: Renderer2,
        private changeDetector: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.loadListener = this.renderer.listen(this.img.nativeElement, 'load', this.onImgLoad);
    }

    ngOnDestroy(): void {
        this.loadListener?.();
        this.renderer.destroy();
    }

    get silkVisible(): boolean {
        return this.isSilkLoaded;
    }

    private onImgLoad = (e: Event) => {
        this.isSilkLoaded = true;
        this.changeDetector.markForCheck();
    };
}
